// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var MM_proof_verifier = require("./MM_proof_verifier.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function rightPad(content, $$char, totalLen) {
  var contentLen = content.length;
  if (totalLen <= contentLen) {
    return content;
  } else {
    return content + $$char.repeat(totalLen - contentLen | 0);
  }
}

function leftPad(content, $$char, totalLen) {
  var contentLen = content.length;
  if (totalLen <= contentLen) {
    return content;
  } else {
    return $$char.repeat(totalLen - contentLen | 0) + content;
  }
}

function maxLength(arr) {
  return arr.map(function (prim) {
                return prim.length;
              }).reduce((function (prim0, prim1) {
                return Math.max(prim0, prim1);
              }), 0);
}

function proofTableToArrStr(ctx, tbl) {
  var srcsArgs = tbl.map(function (r) {
        var src = r.proof;
        if (src.TAG === /* Hypothesis */0) {
          return "";
        } else {
          return src.args.map(function (i) {
                        return i + 1 | 0;
                      }).join(",");
        }
      });
  var srcsLabels = tbl.map(function (r) {
        var src = r.proof;
        if (src.TAG === /* Hypothesis */0) {
          return src.label;
        } else {
          return src.label;
        }
      });
  var exprs = tbl.map(function (r) {
        return MM_context.ctxIntsToStrExn(ctx, r.expr);
      });
  var maxNumOfDigits = Js_math.floor_int(Math.log10(tbl.length)) + 1 | 0;
  var numColWidth = maxNumOfDigits + 1 | 0;
  var argsColWidth = maxLength(srcsArgs) + 1 | 0;
  var labelColWidth = maxLength(srcsLabels) + 1 | 0;
  return tbl.map(function (param, i) {
              return leftPad(String(i + 1 | 0), " ", numColWidth) + "| " + rightPad(Caml_array.get(srcsArgs, i), " ", argsColWidth) + "| " + rightPad(Caml_array.get(srcsLabels, i), " ", labelColWidth) + "| " + Caml_array.get(exprs, i);
            });
}

function proofTableToStr(ctx, tbl, title) {
  var proofTableArrStr = proofTableToArrStr(ctx, tbl);
  var tableWidth = maxLength(proofTableArrStr);
  return rightPad("--- " + title + " ", "-", tableWidth) + "\n" + proofTableArrStr.join("\n") + "\n" + rightPad("", "-", maxLength(proofTableArrStr));
}

function proofTablePrint(ctx, tbl, title) {
  console.log(proofTableToStr(ctx, tbl, title));
}

function traverseIdxsInRpnOrder(tbl, rootIdx, onUse, onReuse) {
  var saved = Belt_HashSetInt.make(64);
  Expln_utils_data.traverseTree(undefined, rootIdx, (function (param, idx) {
          var match = Caml_array.get(tbl, idx).proof;
          if (match.TAG === /* Hypothesis */0 || Belt_HashSetInt.has(saved, idx)) {
            return ;
          } else {
            return match.args;
          }
        }), undefined, undefined, (function (param, idx) {
          var match = Caml_array.get(tbl, idx).proof;
          if (match.TAG === /* Hypothesis */0) {
            Curry._1(onUse, idx);
          } else if (Belt_HashSetInt.has(saved, idx)) {
            Curry._1(onReuse, idx);
          } else {
            Belt_HashSetInt.add(saved, idx);
            Curry._1(onUse, idx);
          }
        }), undefined);
}

function collectReusedIdxs(tbl, rootIdx) {
  var reused = Belt_HashSetInt.make(64);
  traverseIdxsInRpnOrder(tbl, rootIdx, (function (param) {
          
        }), (function (idx) {
          Belt_HashSetInt.add(reused, idx);
        }));
  return reused;
}

function createProof(mandHyps, tbl, rootIdx) {
  var tblLen = tbl.length;
  if (tblLen <= rootIdx) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "tblLen <= rootIdx"
          },
          Error: new Error()
        };
  }
  var mandHypLen = mandHyps.length;
  var mandHypLabelToInt = Belt_HashMapString.fromArray(mandHyps.map(function (param, i) {
            return [
                    param.label,
                    i + 1 | 0
                  ];
          }));
  var labels = [];
  var labelToIntMap = Belt_HashMapString.make(64);
  var labelToInt = function (label) {
    var i = Belt_HashMapString.get(mandHypLabelToInt, label);
    if (i !== undefined) {
      return i;
    }
    var i$1 = Belt_HashMapString.get(labelToIntMap, label);
    if (i$1 !== undefined) {
      return i$1;
    }
    labels.push(label);
    var res = mandHypLen + labels.length | 0;
    Belt_HashMapString.set(labelToIntMap, label, res);
    return res;
  };
  var reusedIdxs = collectReusedIdxs(tbl, rootIdx);
  var reusedIdxToInt = Belt_HashMapInt.make(64);
  var proofSteps = [];
  traverseIdxsInRpnOrder(tbl, rootIdx, (function (idx) {
          var match = Caml_array.get(tbl, idx).proof;
          var stepNum;
          stepNum = match.TAG === /* Hypothesis */0 ? labelToInt(match.label) : labelToInt(match.label);
          proofSteps.push(stepNum);
          if (Belt_HashSetInt.has(reusedIdxs, idx)) {
            proofSteps.push(0);
            return Belt_HashMapInt.set(reusedIdxToInt, idx, Belt_HashMapInt.size(reusedIdxToInt) + 1 | 0);
          }
          
        }), (function (idx) {
          proofSteps.push(-Belt_Option.getExn(Belt_HashMapInt.get(reusedIdxToInt, idx)) | 0);
        }));
  var labelsLastIdx = mandHypLen + labels.length | 0;
  return {
          TAG: /* Compressed */1,
          labels: labels,
          compressedProofBlock: proofSteps.map(function (i) {
                  if (i === 0) {
                    return "Z";
                  } else if (i < 0) {
                    return MM_proof_verifier.intToCompressedProofStr(labelsLastIdx - i | 0);
                  } else {
                    return MM_proof_verifier.intToCompressedProofStr(i);
                  }
                }).join("")
        };
}

function createProofTableFromProof(proofNode, mergeSameRowsOpt, param) {
  var mergeSameRows = mergeSameRowsOpt !== undefined ? mergeSameRowsOpt : true;
  var nodeIdToIdx = Belt_HashMapInt.make(MM_proof_verifier.proofNodeGetId(proofNode));
  var tbl = [];
  var saveExprToTblWithoutChecks = function (nodeId, expr, proof) {
    var idx = tbl.push({
          expr: expr,
          proof: proof
        }) - 1 | 0;
    Belt_HashMapInt.set(nodeIdToIdx, nodeId, idx);
  };
  var saveExprToTbl = function (nodeId, expr, proof) {
    if (Belt_Option.isSome(Belt_HashMapInt.get(nodeIdToIdx, nodeId))) {
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "getIdxByNodeId(nodeId)->Belt_Option.isSome in createProofTableFromProof()"
            },
            Error: new Error()
          };
    }
    if (!mergeSameRows) {
      return saveExprToTblWithoutChecks(nodeId, expr, proof);
    }
    var idx = tbl.findIndex(function (r) {
          if (MM_context.exprEq(r.expr, expr)) {
            return Caml_obj.equal(r.proof, proof);
          } else {
            return false;
          }
        });
    if (idx !== -1) {
      return Belt_HashMapInt.set(nodeIdToIdx, nodeId, idx);
    } else {
      return saveExprToTblWithoutChecks(nodeId, expr, proof);
    }
  };
  Expln_utils_data.traverseTree(undefined, proofNode, (function (param, node) {
          if (node.TAG === /* Hypothesis */0) {
            return ;
          } else {
            return node.args;
          }
        }), undefined, undefined, (function (param, node) {
          if (node.TAG === /* Hypothesis */0) {
            var id = node.id;
            if (Belt_Option.isNone(Belt_HashMapInt.get(nodeIdToIdx, id))) {
              saveExprToTbl(id, node.expr, {
                    TAG: /* Hypothesis */0,
                    label: node.hypLabel
                  });
            }
            
          } else {
            var id$1 = node.id;
            if (Belt_Option.isNone(Belt_HashMapInt.get(nodeIdToIdx, id$1))) {
              saveExprToTbl(id$1, node.expr, {
                    TAG: /* Assertion */1,
                    args: node.args.map(function (argNode) {
                          var nodeId = MM_proof_verifier.proofNodeGetId(argNode);
                          var idx = Belt_HashMapInt.get(nodeIdToIdx, nodeId);
                          if (idx !== undefined) {
                            return idx;
                          }
                          throw {
                                RE_EXN_ID: MM_parser.MmException,
                                _1: {
                                  msg: "Could not determine idx by nodeId in createProofTableFromProof()."
                                },
                                Error: new Error()
                              };
                        }),
                    label: node.asrtLabel
                  });
            }
            
          }
        }), undefined);
  return tbl;
}

exports.createProof = createProof;
exports.createProofTableFromProof = createProofTableFromProof;
exports.proofTableToArrStr = proofTableToArrStr;
exports.proofTableToStr = proofTableToStr;
exports.proofTablePrint = proofTablePrint;
/* MM_context Not a pure module */
